module.exports = __webpack_public_path__ + "img/seta_branca.5f3553ca.svg";